module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('img', {
    attrs: {
      "alt": "img2.jpg",
      "height": "48",
      "src": "Images/img2.jpg",
      "width": "48"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Pubblicato da")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Questa è un’opera di fantasia. Nomi, personaggi, luoghi e avvenimenti sono il prodotto dell’immaginazione dell’autore o sono usati in modo fittizio e ogni somiglianza a persone reali, vive o morte, imprese commerciali, eventi o località è puramente casuale.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Salvare Sean")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Copyright dell’edizione italiana © 2015 Dreamspinner Press.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Saving Sean")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("© 2012 Con Riley.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Traduzione di Rebecca Cornia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Illustrazione di copertina di")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("© 2012 Anne Cain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("annecain.art@gmail.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Le immagini di copertina sono usate a soli scopi illustrativi e i soggetti ritratti in esse sono modelli.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Tutti i diritti riservati. Nessuna parte di questo libro può essere riprodotta o trasmessa in alcuna forma o con alcun mezzo, elettronico o meccanico, incluse fotocopie, registrazioni, o da qualsiasi sistema di deposito e recupero di informazioni senza il permesso scritto dell’Editore, eccetto laddove permesso dalla legge. Per richiedere il permesso e per qualunque altra domanda, contattare Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886, USA or http://www.dreamspinnerpress.com/.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Edizione eBook italiano: 978-1-62380-744-3")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Prima edizione italiana: Luglio 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Prima Edizione Aprile 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Stampato negli Stati Uniti d’America.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0